export default __webpack_public_path__ + "static/media/halftone_gijs.6ca02bca.png";